var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.833h-7m7 0h5.833l-1.639-1.639A2.372 2.372 0 0118 14.518v-3.685a7.002 7.002 0 00-4.667-6.602v-.398a2.333 2.333 0 00-4.666 0v.398A7.005 7.005 0 004 10.833v3.686c0 .627-.25 1.23-.694 1.675l-1.64 1.64H14.5zm0 0V19a3.5 3.5 0 11-7 0v-1.167h7z",
    stroke: "#4A5568",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/bell.3a5adb16.svg";
export { SvgBell as ReactComponent };